require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./interviste-susanne-wettstein.json") })
        }
      }, "path---interviste-susanne-wettstein");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---interviste-susanne-wettstein!./.cache/json/interviste-susanne-wettstein.json
// module id = 689
// module chunks = 231608221292675